import { TEvent } from "@/types/event";

const getEventActivity = (event?: TEvent) => {
  for (const activity of event?.extendedProps.eventMaster?.activities || []) {
    if (activity.id === event?.extendedProps.activityId) {
      if (
        activity.activityCategories.find(
          (c) => c.id === event?.extendedProps.activityCategoryId
        )
      ) {
        return activity;
      }
    }
  }

  // backup: it should b=never reach here
  return event?.extendedProps.eventMaster?.activities.find(
    (a) => a.id === event.extendedProps.activityId
  );
};
export default getEventActivity;
